import React, { useEffect } from "react";
import ChooseWaterUser from "./ChooseWaterUser/ChooseWaterUser";
import { useParams } from "react-router";
import { Box } from "@material-ui/core";
import CitiesContainer from "./WaterUserVisualization/Cities/CitiesContainer";
import TribesContainer from "./WaterUserVisualization/Tribes/TribesContainer";
import AgricultureContainer from "./WaterUserVisualization/Agriculture/AgricultureContainer";
import IndustryContainer from "./WaterUserVisualization/Industry/IndustryContainer";
import userActions from "./WaterUserVisualization/common/actions";

const WaterUserContainer = () => {
  const { type } = useParams();
  const { setWaterUser } = userActions();
  
  const waterUserHook = () => {
    setWaterUser(type);
  }
  useEffect(waterUserHook, [type]);

  return (
    <Box>
      {type === undefined ? (
        <ChooseWaterUser />
      ) : type === "cities" ? (
        <CitiesContainer />
      ) : type === "tribes" ? (
        <TribesContainer />
      ) : type === "agriculture" ? (
        <AgricultureContainer />
      ) : type === "industry" ? (
        <IndustryContainer />
      ) : null}
    </Box>
  );
};

export default WaterUserContainer;
